import axios from '../javascript/custom-axios'
const V1 = '/v1'
const RESOURCE_NAME = '/authentication'
const RESOURCE_NAME2 = '/users'

export default {
  login(username, password) {
    return axios.post(`${V1}${RESOURCE_NAME}/login`, { username, password })
  },

  confirmLogin(body) {
    return axios.post(`${V1}${RESOURCE_NAME}/confirmlogin`, body)
  },

  loginWithoutSms(username, password) {
    return axios.post(`${V1}${RESOURCE_NAME}/login/withoutsms`, { username, password })
  },

  resetPassword(body) {
    console.log('body reset password : ', body)
    return axios.post(`${V1}${RESOURCE_NAME2}/forgotPassword`, body)
  },

  confirmNewPassword(body) {
    console.log('body confirm password : ', body)
    return axios.post(`${V1}${RESOURCE_NAME2}/confirmForgotPassword`, body)
  },

  getKvkkText() {
    return axios.get(`${V1}${RESOURCE_NAME}/kvkk`)
  },

  logoutUser() {
    return axios.get(`${V1}${RESOURCE_NAME}/logout`)
  },

  getRemoteConfig() {
    return axios.get(`${V1}/files/forceupdate`)
  },
}
